import React, { Component } from 'react';
import {
  func, arrayOf, string, oneOfType, number
} from 'prop-types';
import moment from 'moment/moment';
import Collapsible from 'react-collapsible';

import { courseUnitRealisationType } from '../../../constants/types';
import { getTranslation, withLang, langType } from '../../../i18n';
import Tag from '../../Tag';

import styles from '../surveyParticipantsEditor.module.css';
import foldableListStyles from '../../FoldableList/foldableList.module.css';
import FoldableList from '../../FoldableList';
import Notification from '../../Notification';

const FOLD_THRESHOLD = 10;

class CourseList extends Component {
  constructor(props) {
    super(props);

    this.handleRemoveCourse = this.handleRemoveCourse.bind(this);
    this.renderCourses = this.renderCourses.bind(this);
    this.renderCourseRow = this.renderCourseRow.bind(this);
  }

  handleRemoveCourse(event) {
    const { removeCourse, surveyType, surveyId } = this.props;
    const courseId = event.target.getAttribute('data-course-id');
    removeCourse(courseId, surveyType, surveyId);
  }

  renderCourseRow(course) {
    const { lang, translate: t } = this.props;
    const {
      code, courseName, startDate, endDate, warning
    } = course;

    const courseTitle = warning
      ? `${code} -`
      : `${code}, ${getTranslation(courseName, lang)}, ${moment(startDate).format('D.M.Y')} - ${moment(endDate).format('D.M.Y')}`;

    const removeButton = () => (
      <button
        type="button"
        data-course-id={course.id}
        className={`${styles.button} icon--remove iconButton`}
        onClick={this.handleRemoveCourse}
        title={t('common.remove')}
        data-cy="remove-course-button"
      />
    );

    const createAccordionTitle = (active) => {
      const activeClassName = active ? 'is-active' : '';

      return (
        <div className={`${styles.courseTitleWrapper} accordion__title button--accordion theme-transparent ${activeClassName}`}>
          <div className={styles.courseTitle}>
            <span>{courseTitle}</span>
            {course.new && <Tag text={t('common.new')} inverse={!active} />}
          </div>
          {removeButton()}
        </div>
      );
    };

    const renderParticipants = (students) => (
      <table>
        <thead>
          <tr>
            <th>{t('common.name')}</th>
            <th>{t('common.email')}</th>
            <th>{t('common.studentNumber')}</th>
          </tr>
        </thead>
        <tbody>
          {students.map((student) => (
            <tr key={student.studentNumber}>
              <td>{student.name}</td>
              <td>{student.email}</td>
              <td>{student.studentNumber}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );

    return (
      <Collapsible
        key={code}
        trigger={createAccordionTitle(false)}
        triggerWhenOpen={createAccordionTitle(true)}
      >
        <div className={`accordion__item ${styles.courseAccordionItem}`}>
          <p>{t('startSurvey.courseList.courseCode', { code })}</p>
          {warning
            ? <p>{t('surveyParticipantsEditor.missingCourseName')}</p>
            : (
              <>
                <Notification text={t('startSurvey.courseList.participantsInfo')} />
                <p>{t('startSurvey.courseList.numberOfParticipants', { amount: course.students.length })}</p>
                <FoldableList
                  foldThreshold={FOLD_THRESHOLD}
                  noElementsMessage={t('startSurvey.noSelectedParticipants')}
                  renderFunction={renderParticipants}
                >
                  {course.students}
                </FoldableList>
              </>
            )}
        </div>
      </Collapsible>
    );
  }

  renderCourses(courses) {
    return (
      <div className={`${styles.courseAccordionWrapper}`}>
        {courses.map(this.renderCourseRow)}
      </div>
    );
  }

  render() {
    const { translate: t, courses } = this.props;

    return (
      <div>
        <h3>{t('startSurvey.courses')}{courses.length ? ` (${courses.length})` : ''}</h3>
        {courses.length
          ? this.renderCourses(this.props.courses)
          : <p className={foldableListStyles.noElements}>{t('startSurvey.courseList.noSelectedCourses')}</p>}
      </div>
    );
  }
}

CourseList.defaultProps = {
  surveyId: null
};

CourseList.propTypes = {
  courses: arrayOf(courseUnitRealisationType).isRequired,
  removeCourse: func.isRequired,
  surveyType: string.isRequired,
  surveyId: oneOfType([string, number]),
  ...langType
};

export default withLang(CourseList);
